import { generateUniqueId, stripTimestampAndExtension } from '@/assets/js/Utilities';
import { readAndCompressImage } from "browser-image-resizer";
import Cookies from "js-cookie";
import $ from "jquery";


export default class ColourMatchV2 {
    constructor() {
        this.blockName = 'colour-match-v2';
        this.worker = null;
        this.quality = 1;
        this.maxWidth = 512;
        this.maxHeight = 512;

        this.opacity = {
            minValue: 0,
            maxValue: 100,
        };

        this.defaultPreset = {
            ColorSpace: 1,
            CrossCovarianceLimit: 0,
            ReshapingIterations: 0,
            PercentSaturationShift: 100,
            PercentShadingShift: 100,
            ExtraShading: false,
            ScaleRatherThanClip: false,
            PercentTint: 100,
            PercentModified: 100,
        }

        this.presets = [
            {
                name: 'Correlative 1 Pure',
                id: 7,
                values: {
                    ColorSpace: 1,
                    CrossCovarianceLimit: 50,
                    ReshapingIterations: 1,
                    PercentSaturationShift: 100,
                    PercentShadingShift: 0,
                    ExtraShading: true,
                    ScaleRatherThanClip: true,
                    PercentTint: 100,
                    PercentModified: 100,
                }
            },
            {
                name: 'Correlative 2 Pure',
                id: 8,
                values: {
                    ColorSpace: 0,
                    CrossCovarianceLimit: 50,
                    ReshapingIterations: 1,
                    PercentSaturationShift: 100,
                    PercentShadingShift: 0,
                    ExtraShading: true,
                    PercentTint: 100,
                    PercentModified: 100,
                }
            },
            {
                name: 'Linear 1',
                id: 3,
                values: {
                    ColorSpace: 1,
                    CrossCovarianceLimit: 0,
                    ReshapingIterations: 0,
                    PercentSaturationShift: 100,
                    PercentShadingShift: 100,
                    ExtraShading: false,
                    ScaleRatherThanClip: false,
                    PercentTint: 100,
                    PercentModified: 100,
                }
            },
            {
                name: 'Linear 2',
                id: 4,
                values: {
                    ColorSpace: 0,
                    CrossCovarianceLimit: 0,
                    ReshapingIterations: 0,
                    PercentSaturationShift: 100,
                    PercentShadingShift: 100,
                    ExtraShading: false,
                    PercentTint: 100,
                    PercentModified: 100,
                }
            },
            {
                name: 'Correlative 1 Saturated',
                id: 5,
                values: {
                    ColorSpace: 1,
                    CrossCovarianceLimit: 50,
                    ReshapingIterations: 1,
                    PercentSaturationShift: 100,
                    PercentShadingShift: 50,
                    ExtraShading: true,
                    ScaleRatherThanClip: true,
                    PercentTint: 100,
                    PercentModified: 100,
                }
            },
            {
                name: 'Correlative 2 Saturated',
                id: 6,
                values: {
                    ColorSpace: 0,
                    CrossCovarianceLimit: 50,
                    ReshapingIterations: 1,
                    PercentSaturationShift: 100,
                    PercentShadingShift: 50,
                    ExtraShading: true,
                    PercentTint: 100,
                    PercentModified: 100,
                }
            },
            {
                name: 'Correlative 1 Full',
                id: 9,
                values: {
                    ColorSpace: 1,
                    CrossCovarianceLimit: 50,
                    ReshapingIterations: 1,
                    PercentSaturationShift: 100,
                    PercentShadingShift: 100,
                    ExtraShading: true,
                    ScaleRatherThanClip: true,
                    PercentTint: 100,
                    PercentModified: 100,
                }
            },
            {
                name: 'Correlative 2 Full',
                id: 10,
                values: {
                    ColorSpace: 0,
                    CrossCovarianceLimit: 50,
                    ReshapingIterations: 1,
                    PercentSaturationShift: 100,
                    PercentShadingShift: 100,
                    ExtraShading: true,
                    PercentTint: 100,
                    PercentModified: 100,
                }
            },
        ];
    }

    async addBlock(blockNum = lutify.blocks.length, selectedSampleFile = false) {
        UI.createAdjustmentBlockTemplate(this.blockName, blockNum);
        let element = UI.getAdjustmentBlock(blockNum);

        await this.initWorker();
        this.addRegenerateButton($(element));

        $(element).find(".range_slider").on("input", e => {
            blocks.checkSwitchHandler($(element));
            this.sliderHandler(e);
        });

        $(element).find(".range_value").on("change", e => {
            blocks.checkSwitchHandler($(element));
            this.sliderHandler(e);
        });

        $(element).find(".lut-selector__label-container").on("click", e => {
            e.stopPropagation();
            this.togglePresetSelector($(e.currentTarget));
        });

        $(element).find(".btn-reset-block").on("click", e => this.resetBlock($(element)));

        $(element).on("click", e => {
            e.stopImmediatePropagation();
            // UI.hideLUTtemplates();
            if (!lutify.getActiveBlock().sampleFile) return;
            if (!luts['LUTcontrols'][`ColourMatch-${lutify.getActiveBlock().passes[0].uid}`]) return;
            if (luts['LUTcontrols'][`ColourMatch-${lutify.getActiveBlock().passes[0].uid}`].length == 0) return;
            this.showPreviews();
        });

        $(element).find('.sample-selector').on('click', e => {
            vm.$root.projectTree.openColourMatchV2Modal(vm.$store.state.Projects.currentFile, 'updateColourMatchSample');
        });

        $(element).find(".opacity_slider").on("input", e => this.opacitySliderHandler($(element), e));
        $(element).find(".opacity-input").on("change", e => this.opacityInputHandler($(element), e));

        $(element).find(".btn-reset-block").on("click", e => this.resetBlock($(element)));

        UI.initKnob(element, {
            size: 30,
        });

        blocks.add({
            name: "ColourMatchV2",
            passes: [this.addPass()],
            predictions: [],
            predictionsContent: [],
            blockNum,
            blendingMode: 0,
            blendingModeName: "Normal",
            presetId: null,
            sampleFile: null,
            targetPixels: null,
            samplePixels: null,
            opacity: 100,
            isVideo: vm.$store.state.UI.video.isLoaded,
            sampleVideoTime: vm.$store.state.UI.video.currentTimeMs,
            values: { ...this.defaultPreset }
        });

        this.setPresetList($(element));

        $(element).find(".lut-selector__items-container").hide();
        $(element).find(".expand_options").trigger("click", [false]);

        if (!vm.$store.state.UI.showAddMatchTooltip && vm.$store.getters['Projects/allMatches'].length == 0) {
            vm.$store.dispatch('UI/setAddMatchTooltip', "Please load a reference image first, then save it as a Match using the option above to start using the Colour Match tool");
        }

        if (!Cookies.get("ColourMatchToolNotice")) {
            UI.hideModal();
            UI.showModal(UI.modals.blocks.warnings.colourMatchTool);
        }
    }

    async initWorker() {
        if (this.worker) return;
        this.worker = new Worker("/assets/vendor/colourMatch/CTworker.1.5.js?v=1.0.1");
        await new Promise(resolve => {
            this.worker.addEventListener('message', e => {
                resolve();
            });
        })
    }

    setPresetList($block) {
        this.presets.forEach(preset => {
            let el = document.createElement('span');
            el.innerHTML = preset.name;
            el.setAttribute('data-preset-id', preset.id);
            el.addEventListener('click', e => {
                this.onPresetSelection(e.currentTarget, preset);
            });

            $block.find('.lut-selector__items-container').append(el)
        });
    }

    addRegenerateButton($element) {
        let icon = document.createElement('i')
        icon.setAttribute('class', 'btn-block-regenerate material-icons')
        icon.setAttribute('data-tippy-content', 'Regenerate')
        icon.innerHTML = 'loop'
        icon.addEventListener('click', async () => {
            UI.appendBlockLoadingSpinner($element)

            lutify.getActiveBlock().passes[0].uid = generateUniqueId();
            await this.apply();

            if (lutify.getActiveBlock().presetId) {
                let preset = this.presets.find(preset => preset.id === lutify.getActiveBlock().presetId);
                this.onPresetSelection(null, preset)
            }

            UI.removeBlockLoadingSpinner($element)
        })
        $element.find('.header-container .controls-wrapper').prepend(icon)
    }

    opacitySliderHandler($element, e) {
        let opacityValue = e.currentTarget.value;
        let calcOpacityValue = opacityValue * 0.01;

        $element.find(".opacity-input").val(opacityValue);

        lutify.getActiveBlock().opacity = opacityValue;
        lutify.getActiveBlock().passes[0].uniforms.opacity.value = calcOpacityValue;

        if (lutify.getActiveBlock().sampleFile) {
            lutPreviewer.updateOpacity(calcOpacityValue, 0);
        }

        gpu.render();
        lutPreviewer.render();
    }

    opacityInputHandler($element, e) {
        let opacityValue = e.currentTarget.value;
        let opacitySlider = $element.find(".opacity_slider");

        if (opacityValue > this.opacity.maxValue) opacityValue = this.opacity.maxValue;
        if (opacityValue < this.opacity.minValue) opacityValue = this.opacity.minValue;

        opacitySlider.val(opacityValue);
        opacitySlider.trigger("input");
    }

    async setTargetPixels() {
        let blockNum = blocks.getBlockIndex_byBlockNum(lutify.getActiveBlock().blockNum);
        let passes = blocks.getAllPassesToBlock(blockNum);
        let targetImg = lutify.getIDTLMTimage(passes);

        let compressedImage = await readAndCompressImage(
            loader.dataURLtoFile(targetImg, `target.jpg`),
            {
                quality: this.quality,
                maxWidth: this.maxWidth,
                maxHeight: this.maxHeight,
            }
        );

        let compressedImageURL = URL.createObjectURL(compressedImage)
        lutify.getActiveBlock().targetPixels = await this.getPixels(compressedImageURL);
        URL.revokeObjectURL(compressedImageURL);
    }

    async apply(predict = true) {
        try {
            vm.$store.dispatch('App/setBlockLoading', true);
            $('#blocks-container--outer').addClass('--overlay');
            $('#project-navigator-container').addClass('--overlay');
            $('#filmstrip-container .thumbnail-container').addClass('--overlay');

            vm.$store.dispatch("Loader/showProgressBar", "indeterminate");
            UI.appendBlockLoadingSpinner($(UI.getActiveBlock()));

            if (lutify.getActiveBlock().isVideo) {
                lutify.getActiveBlock().sampleVideoTime = vm.$store.state.UI.video.currentTimeMs;
            }

            setTimeout(() => {
                UI.togglePreviewsContainer();
                lutPreviewer.showPlaceholderPreviews()
            }, 50);

            await this.setTargetPixels();

            if (predict) {
                const { predictions, predictionsContent } = await this.createPredictions();
                lutify.getActiveBlock().predictions = [...predictions];
                lutify.getActiveBlock().predictionsContent = [...predictionsContent];
            }

            const luts = await this.loadLutsFromPredictions(lutify.getActiveBlock().predictions)

            lutPreviewer.createPreviews(luts, false, undefined, 'ColourMatchV2');

            lutPreviewer.removePlaceholderPreviews();
            UI.getActiveBlock().click();

            gpu.render();

            vm.$store.dispatch("Loader/showProgressBar", false);
            UI.removeBlockLoadingSpinner($(UI.getActiveBlock()));
        } finally {
            vm.$store.dispatch('App/setBlockLoading', false);
            $('#blocks-container--outer').removeClass('--overlay');
            $('#project-navigator-container').removeClass('--overlay');
            $('#filmstrip-container .thumbnail-container').removeClass('--overlay');
            vm.$store.dispatch("Loader/showProgressBar", false);
        }
    }

    async loadLutsFromPredictions(predictions) {
        const loadedLuts = [];

        for await (const [key, prediction] of predictions.entries()) {
            const [lut] = await window.luts.load([prediction]);
            lut.control = 'LUTcontrols';
            lut.category = `ColourMatch-${lutify.getActiveBlock().passes[0].uid}`;
            lut.title = this.presets[key].name;
            lut.presetId = this.presets[key].id;

            loadedLuts.push(lut);
        }

        window.luts['LUTcontrols'][`ColourMatch-${lutify.getActiveBlock().passes[0].uid}`] = loadedLuts;
        return loadedLuts;
    }

    async createPredictions() {
        const predictions = [];
        const predictionsContent = [];

        for await (const [key, preset] of this.presets.entries()) {
            const { lutFile, lutContent } = await this.predict(preset.values);
            predictions.push(lutFile);
            predictionsContent.push(lutContent);
        }

        return {
            predictions, predictionsContent
        }
    }

    predict(values, targetPixels, samplePixels) {
        if (!values) values = lutify.getActiveBlock().values;
        if (!targetPixels) targetPixels = lutify.getActiveBlock().targetPixels;
        if (!samplePixels) samplePixels = lutify.getActiveBlock().samplePixels;

        return new Promise(resolve => {
            this.worker.postMessage([values, targetPixels, samplePixels]);
            this.worker.onmessage = e => {
                const lutContent = new TextDecoder().decode(e.data.lut_copy);
                const lutFile = new File([lutContent], "colour-match.cube", { type: "text/plain" });

                resolve({
                    lutFile,
                    lutContent
                });
            }
        })
    }

    addPass() {
        let pass = gpu.createRenderPass();
        gpu.addPassToComposer(pass, "toMiddle");
        return pass;
    }

    togglePresetSelector($el) {
        let itemsContainer = $el.siblings(".lut-selector__items-container");
        if (itemsContainer.is(":visible")) itemsContainer.hide();
        else itemsContainer.show();
    }

    onPresetSelection(el, preset) {
        let category = 'ColourMatch-' + lutify.getActiveBlock().passes[0].uid;

        if ($(`#previews-list-container .list-item[data-category="${category}"][data-preset-id="${preset.id}"]`).length > 0) {
            $(`#previews-list-container .list-item[data-category="${category}"][data-preset-id="${preset.id}"]`).trigger('click');
        } else {
            this.setBlockValues($(UI.getActiveBlock()), preset);
            $(UI.getActiveBlock()).find('#apply-colour-match').trigger('click');

            let id = el.getAttribute('data-preset-id');
            let name = $(el).html();

            this.updatePresetList(id, name);
        }
    }

    updatePresetList(id, name) {
        let $lutSelector = $(UI.getActiveBlock()).find(".lut-selector");
        $lutSelector.find(".lut-selector__items-container").hide();
        $lutSelector.find(".selected-lut-name").html(name);

        $lutSelector
            .find(`.lut-selector__items-container .--selected`)
            .removeClass("--selected");

        $lutSelector
            .find(`.lut-selector__items-container span[data-preset-id="${id}"]`).addClass("--selected");
    }

    sliderHandler(e) {
        if (e.originalEvent) {
            lutify.getActiveBlock().presetId = 0;
            this.updatePresetList(lutify.getActiveBlock().presetId, 'Custom');
        }

        let $element = $(e.currentTarget);
        // $(UI.getActiveBlock()).find('.btn-block-needs-update').removeClass('hide');

        let value = parseFloat($element.val());
        let control = $element.data("control");

        if ($element.hasClass("range_value")) {
            if (value > parseInt($element.attr("max"))) {
                value = parseInt($element.attr("max"));
                $element.val(value);
            }
            if (value < parseInt($element.attr("min"))) {
                value = parseInt($element.attr("min"));
                $element.val(value);
            }
        }

        if ($element.hasClass("range_slider")) {
            $element.closest(".block-sliders-container").find(".range_value").val(value);
        } else {
            $element.closest(".block-sliders-container").find(".range_slider").val(value);
        }

        lutify.getActiveBlock().values[control] = value;
    }

    setBlockValues($block, preset) {
        lutify.getActiveBlock().presetId = preset.id;
        lutify.getActiveBlock().values = { ...preset.values };

        Object.keys(preset.values).forEach(key => {
            let control = $block.find(`[data-control="${key}"]`);
            if (!control) return;

            if (control.attr('type') == 'range') {
                control.val(preset.values[key]);
                control.trigger("input");
            } else {
                control.attr('checked', preset.values[key]);
                control.trigger('change');
            }
        });
    }

    async getPixels(targetImage) {
        let img = new Image();
        img.src = targetImage;
        await img.decode();

        let size = lutify.getConstrainedImageSize(img.width, img.height);
        UI.colourMatchCanvas.setSize(size.width, size.height);
        UI.colourMatchCanvas.el.getContext('2d').drawImage(img, 0, 0, size.width, size.height);
        return UI.colourMatchCanvas.el.getContext('2d').getImageData(0, 0, size.width, size.height);
    }

    async setSampleFile(file) {
        lutify.getActiveBlock().passes[0].uid = generateUniqueId();

        blocks.checkSwitchHandler($(UI.getActiveBlock()));

        lutify.getActiveBlock().sampleFile = {
            id: file.id,
            type: file.type,
        };

        let match = vm.$store.getters["Projects/assetById"](file.id, file.type);
        let matchStoreData = await lutify.fetchMatch(match);

        let compressedImage = await readAndCompressImage(
            matchStoreData.imageIDTLMT,
            {
                quality: this.quality,
                maxWidth: this.maxWidth,
                maxHeight: this.maxHeight,
            }
        );

        let compressedImageURL = URL.createObjectURL(compressedImage)
        lutify.getActiveBlock().samplePixels = await this.getPixels(compressedImageURL);
        URL.revokeObjectURL(compressedImageURL);

        this.setSampleFileUI(matchStoreData.blob, match.name);

        this.resetOpacity();
    }

    setSampleFileUI(imageBlob, name) {
        if (!lutify.getActiveBlock()) return;
        let block = UI.getActiveBlock();
        let $block = $(block);

        let imgSrc = URL.createObjectURL(imageBlob);
        let imgElement = document.createElement('img');
        imgElement.setAttribute('src', imgSrc);
        imgElement.setAttribute('class', 'thumbnail');
        imgElement.setAttribute('data-tippy-content', 'Click to change a Match');

        $block.find('.sample-selector img').remove();
        $block.find('.sample-selector .select-asset-btn').addClass('hide');
        $block.find('.sample-selector').prepend(imgElement);

        name = stripTimestampAndExtension(name);
        $block.find('.sample-selector .name').text(`Selected Match: ${name}`);
    }

    resetBlock($element) {
        UI.hideLUTtemplates();

        const pass = gpu.createCopyPass(false);
        let index = gpu.getPassIndexById(lutify.getActiveBlock().passes[0].uid);
        gpu.composer.passes[index] = pass;
        lutify.getActiveBlock().passes[0] = pass;
        gpu.render();

        this.resetOpacity();

        lutify.getActiveBlock().sampleFile = null;
        lutify.getActiveBlock().targetPixels = null;
        lutify.getActiveBlock().samplePixels = null;
        // lutify.getActiveBlock().presetId = null;
        lutify.getActiveBlock().predictions = [];
        lutify.getActiveBlock().predictionsContent = [];

        this.setBlockValues($element, { values: this.defaultPreset })

        this.resetSampleFileUI();

        UI.getActiveBlock().find(".selected-lut-name").html("Select...");

        gpu.render();
        lutPreviewer.render();
    }

    resetOpacity() {
        $(UI.getActiveBlock()).find(".opacity-input").val(100);
        $(UI.getActiveBlock()).find(".opacity-input").trigger("change");
    }

    resetSampleFileUI() {
        if (!lutify.getActiveBlock()) return;
        let $block = UI.getActiveBlock();

        $block.find('.sample-selector img').remove();
        $block.find('.sample-selector .select-asset-btn').removeClass('hide');
        $block.find('.sample-selector .name').text(``);
    }

    showPreviews() {
        lutify.selectedPreviewCategory = `ColourMatch-${lutify.getActiveBlock().passes[0].uid}`;

        UI.togglePreviewsContainer();
        UI.updatePreviewsTab('Colour Match');
        lutPreviewer.switchCanvases(`ColourMatch-${lutify.getActiveBlock().passes[0].uid}`);
        // UI.updateSelectedPreview(lutify.getActiveBlock().selectedPreview);

        lutPreviewer.cloneMainComposerPasses();
        lutPreviewer.addPass('LUTcontrols', `ColourMatch-${lutify.getActiveBlock().passes[0].uid}`, undefined, lutify.getActiveBlock().blendingMode);

        lutPreviewer.render();
        setTimeout(() => lutPreviewer.render(), 50); // because of visual glitch
    }

    async applyChanges($block, values, blockData) {
        if (blockData.presetId) {
            let preset = this.presets.find(preset => preset.id === blockData.presetId);
            this.setBlockValues($block, preset);
            this.updatePresetList(preset.id, preset.name);
        }

        if (blockData.sampleFile) {
            if (!vm.$store.getters["Projects/assetById"](blockData.sampleFile.id, blockData.sampleFile.type)) {
                vm.$snackbar('Selected Match for Colour Match is no longer available. Please select a new one or otherwise remove the AI Colour Extract tool.', 'error', {
                    timeout: -1,
                    contentClass: 'text-center',
                });
                return;
            }

            await this.setSampleFile(blockData.sampleFile);

            if (blockData.isVideo) {
                lutify.getActiveBlock().sampleVideoTime = blockData.sampleVideoTime;
                document.querySelector("#video").currentTime = blockData.sampleVideoTime;
                vm.$store.dispatch('UI/setVideoCurrentTime', blockData.sampleVideoTime);

                // wait for video frame to be rendered
                await new Promise(resolve => {
                    setTimeout(() => {
                        resolve();
                    }, 500);
                });
            }

            lutify.getActiveBlock().predictions = blockData.predictionsContent.map(predictionContent => new File([predictionContent], "colour-match.cube", { type: "text/plain" }));
            lutify.getActiveBlock().predictionsContent = blockData.predictionsContent;

            await this.apply(false);

            if (blockData.presetId) {
                let preset = this.presets.find(preset => preset.id === blockData.presetId);
                this.onPresetSelection(null, preset);
            }

            $block.find(".opacity-input").val(parseInt(blockData.opacity));
            $block.find(".opacity-input").trigger("change");
            $block.find(".controls-wrapper .switch > input").trigger("click");
            window.lutify.getActiveBlock().collapsedPreviews = blockData.collapsedPreviews;
            if (blockData.blendingMode !== 0) $block.find(`.blending-mode__items-container > span[data-id="${blockData.blendingMode}"]`).trigger("click");
        }
    }
}
